import provider from '@root/app/Resources/assets/tracking';
import hasCookieCategoryConsent from '@PayseraServiceAgreementBundle/Resources/assets/js/service/hasCookieCategoryConsent';
import { CATEGORY_STATISTICS, PAYSERA_CONSENT_UPDATED_EVENT } from '@PayseraServiceAgreementBundle/Resources/assets/js/config/constants';
import isConsentRelevant from '@PayseraServiceAgreementBundle/Resources/assets/js/service/isConsentRelevant';
import isTelemetryDisabled from '@assetsJsModule/telemetry/isTelemetryDisabled';

const TRACKING_IFRAME_ID = 'tracking-iframe';

const addTrackingIframe = () => {
    const appendIframe = () => {
        const frame = document.createElement('iframe');
        frame.setAttribute('id', TRACKING_IFRAME_ID);
        frame.setAttribute('src', provider.getUrl(window.location.href, document.referrer));
        frame.setAttribute('class', 'hidden');
        document.body.appendChild(frame);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', appendIframe, { once: true });
    } else {
        appendIframe();
    }
};

const shouldAppendIframe = () => {
    if (isTelemetryDisabled()) {
        return false;
    }

    if (document.getElementById(TRACKING_IFRAME_ID)) {
        return false;
    }

    if (hasCookieCategoryConsent(CATEGORY_STATISTICS)) {
        return true;
    }

    return !isConsentRelevant();
};

if (shouldAppendIframe()) {
    addTrackingIframe();
}

document.addEventListener(PAYSERA_CONSENT_UPDATED_EVENT, () => {
    if (shouldAppendIframe()) {
        addTrackingIframe();
    }
});
